import PropTypes from 'prop-types';
import React, { useState } from 'react';
import ReactPlayer from 'react-player';
import { Modal } from 'react-responsive-modal';

import HeadshotPlaceholder from '../../images/headshot-placeholder.svg';
import { ReactComponent as Caret } from '../../images/icons/caret-right.svg';
import PageSection from '../Common/PageSection';
import SmartLink from '../Common/SmartLink';
import * as styles from './sessionList.module.css';

const SessionList = ({ section }) => {
  const sessions = section.data.sessions;
  // const allDates = [];
  /*let currentDate;*/
  /*section.data.eventDays.map(
    (eventDay) => (
      (currentDate = eventDay.title),
      allDates.push(currentDate),
      eventDay.sessions.map((session) => sessions.push({ date: currentDate, session: session }))
    )
  );*/
  const [filterType, setFilterType] = useState('');
  const [filterDate, setFilterDate] = useState('');
  const [filteredSessions, setFilteredSessions] = useState(sessions);

  function filter(e) {
    if (e.target.name === 'date') {
      let currentDate;
      let data = e.target.value.toString();
      if (filterType !== '') {
        setFilterDate(data);
        let pureSessions = [];
        if (data === 'All') {
          setFilterDate('');
          let eventDay = section.data.eventDays;
          let sessions = [];
          eventDay.map(
            (eDay) => (
              (currentDate = eDay.title),
              eDay.sessions.map((session) => {
                sessions.push({ date: currentDate, session: session });
              })
            )
          );
          for (let j = 0; j < sessions.length; j++) {
            if (sessions[j].session.type === filterType) {
              pureSessions.push(sessions[j]);
            }
          }
          setFilteredSessions(pureSessions);
        } else {
          let eventDay = section.data.eventDays.find((session, idx) => session.title === data);
          let sessions = eventDay.sessions;
          currentDate = eventDay.title;
          for (let j = 0; j < sessions.length; j++) {
            if (sessions[j].type === filterType) {
              pureSessions.push({ date: currentDate, session: sessions[j] });
            }
          }
          setFilteredSessions(pureSessions);
        }
      } else {
        if (data === 'All') {
          setFilterDate('');
          let eventDay = section.data.eventDays;
          let sessions = [];
          eventDay.map((eDay) => {
            currentDate = eDay.title;
            eDay.sessions.map((session) => {
              sessions.push({ date: currentDate, session: session });
            });
          });
          setFilteredSessions(sessions);
        } else {
          let sessions = [];
          setFilterDate(data);
          let eventDay = section.data.eventDays.find((session, idx) => session.title === data);
          currentDate = eventDay.title;
          eventDay.sessions.map((session) => {
            sessions.push({ date: currentDate, session: session });
          });
          setFilteredSessions(sessions);
        }
      }
    } else if (e.target.name === 'type') {
      let currentDate;
      let value = e.target.value;
      if (filterDate !== '') {
        currentDate = filterDate;
        setFilterType(e.target.value);
        let eventDay = section.data.eventDays.find((session, idx) => session.title === filterDate);
        setFilterType(e.target.value);
        let pureSessions = [];
        let sessions = eventDay.sessions;
        for (let j = 0; j < sessions.length; j++) {
          if (sessions[j].type === value) {
            pureSessions.push({ date: currentDate, session: sessions[j] });
          }
        }
        setFilteredSessions(pureSessions);
      } else {
        setFilterType(e.target.value);
        let pureSessions = [];
        for (let i = 0; i < section.data.eventDays.length; i++) {
          currentDate = section.data.eventDays[i].title;
          let sessions = section.data.eventDays[i].sessions;
          for (let j = 0; j < sessions.length; j++) {
            if (sessions[j].type === value) {
              pureSessions.push({ date: currentDate, session: sessions[j] });
            }
          }
        }
        setFilteredSessions(pureSessions);
      }
    }
  }

  return (
    <PageSection noPad fullBleed className={styles.sessionList}>
      <section>
        {filteredSessions?.map((session, i) => {
          if (session.type === 'In-Person + Virtual' && !session.useWhiteBackground) {
            // TODO: Not displaying virtual events for now
            return <InPersonAndVirtual key={i} session={session} />;
          } else {
            return <InPerson key={i} session={session} />;
          }
        })}
      </section>
    </PageSection>
  );

  /* TODO: This will be used when we have confirmed dates
  return (
    <PageSection noPad fullBleed>
      {/!*<FilterSessions pageMeta={section} filter={filter} />*!/}
      {filterDate === '' ? (
        allDates.map((date) => (
          <section>
            <h3 className={styles.eventDate}>{date}</h3>
            {filteredSessions.map((session) =>
              session.date === date ? (
                session.type === 'In-Person + Virtual' ? (
                  <InpersonAndVirtual session={session} />
                ) : (
                  <InPerson sessionInPerson={session} />
                )
              ) : (
                ''
              )
            )}
          </section>
        ))
      ) : (
        <section>
          <h3 className={styles.eventDate}>{filterDate}</h3>
          {filteredSessions.map((session) =>
            session.date === filterDate ? (
              session.type === 'Inperson + Virtual' ? (
                <InpersonAndVirtual session={session} />
              ) : (
                <InPerson sessionInPerson={session} />
              )
            ) : (
              ''
            )
          )}
        </section>
      )}
    </PageSection>
  );*/
};

const Description = ({ session, textColor }) => {
  const descriptionWords = session.description?.split(' ');
  let description = session.description;
  const showMore = descriptionWords?.length > 18;
  if (showMore) {
    description = descriptionWords.join(' ');
  }
  const [showingMore, setMore] = useState(false);
  const more = () => {
    setMore(true);
  };

  return (
    <div className={textColor === 'white' && styles.whiteText}>
      {description && !showMore && <p dangerouslySetInnerHTML={{ __html: description }} />}
      {description && showMore && !showingMore && (
        <p>
          {descriptionWords.slice(0, 15).join(' ')}{' '}
          {!showingMore && (
            <button className={styles.moreButton} onClick={more}>
              ...more
            </button>
          )}
        </p>
      )}
      {description && showingMore && <p dangerouslySetInnerHTML={{ __html: description }} />}
      {session?.takeaways && (
        <>
          <h5>Key Takeaways</h5>
          <ul>
            {session.takeaways.map((item, i) => {
              return <li key={i}>{item}</li>;
            })}
          </ul>
        </>
      )}
    </div>
  );
};

const TrailerModal = ({ trailer }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button className={styles.videoButton} onClick={() => setOpen(true)}>
        <span>Watch Trailer</span>
        <Caret />
      </button>
      <Modal open={open} onClose={() => setOpen(false)} center classNames={{ modal: styles.modal }}>
        <ReactPlayer
          id="modal-video"
          width="100%"
          height="100%"
          controls="true"
          muted="true"
          playing="false"
          url={trailer}
          config={{
            wistia: {
              options: {
                fullscreenButton: false,
                volumeControl: true,
                settingsControl: false,
              },
            },
          }}
        />
      </Modal>
    </>
  );
};

const InPersonAndVirtual = ({ session }) => {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.subContainer}>
        <div className={styles.divisionOne}>
          <div className={styles.sessionTypeAndDate}>
            <p className={styles.sessionType}>{session.type}</p>
            <p className={styles.sessionTime}>{session.date}</p>
            <p className={styles.sessionTime}>{session.time}</p>
          </div>
          {session.trailerUrl && <TrailerModal trailer={session.trailerUrl} />}
          {session.saveSessionUrl && (
            <a href={session.saveSessionUrl} className={styles.saveButton}>
              SAVE SESSION
            </a>
          )}
        </div>
        <div className={styles.divisionTwo}>
          <h3 className={styles.sessionTitle}>{session.title}</h3>
          <Description session={session} textColor="white" />
          <h4 className={styles.venue}> {session.location}</h4>
          <div>
            {session.speakers?.map((speaker, idx) => (
              <div className={styles.sessionSpeaker} key={idx}>
                <div id={speaker.name.replace(' ', '')} className={styles.jumpLink} />
                <div className={styles.speakerImageAvatar}>
                  <img src={speaker.headshotUrl ? speaker.headshotUrl : HeadshotPlaceholder} alt="speakerAvatar" />
                </div>
                <div className={styles.speakerDetails}>
                  <h4 className={styles.speakerName}>{speaker.name}</h4>
                  <p className={styles.speakerTitle}>{speaker.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        {session.saveSessionUrl && (
          <SmartLink to={session.saveSessionUrl} className={styles.saveButtonMobile}>
            SAVE SESSION
          </SmartLink>
        )}
      </div>
    </div>
  );
};

const InPerson = ({ session }) => {
  return (
    <div className={styles.mainContainerInPerson}>
      <div className={styles.subContainerInPerson}>
        <div className={styles.divisionOneInPerson}>
          <div>
            <p className={styles.sessionTypeInPerson}>{session.type}</p>
            <p className={styles.sessionTime}>{session.date}</p>
            <p className={styles.sessionTimeInPerson}>{session.time}</p>
          </div>
          {session.trailerUrl && <TrailerModal trailer={session.trailerUrl} />}
        </div>
        <div className={styles.divisionTwoInPerson}>
          <h3>{session.title}</h3>
          <Description session={session} />
          <h4 className={styles.venueInPerson}> {session.location}</h4>
          <div>
            {session.speakers?.map((speaker, idx) => (
              <div className={styles.sessionSpeakerInPerson} key={idx}>
                <div id={speaker.name.replace(' ', '')} className={styles.jumpLink} />
                <div className={styles.speakerImageAvatarInPerson}>
                  <img src={speaker.headshotUrl ? speaker.headshotUrl : HeadshotPlaceholder} alt="speakerAvatar" />
                </div>

                <div className={styles.speakerDetailsInPerson}>
                  <h4 className={styles.speakerNameInPerson}>{speaker.name}</h4>
                  <p className={styles.speakerTitleInPerson}>{speaker.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <hr />
    </div>
  );
};

SessionList.propTypes = {
  section: PropTypes.object,
};

export default SessionList;
